// @flow
import type {MarkdocTagRegistration} from 'docs/markdoc';
import {ImageSrc, Href} from 'docs/markdoc/attribute-types';

export const PartnerCard: MarkdocTagRegistration = {
  tag: 'partner-card',
  component: 'PartnerCard',
  attributes: {
    title: {
      type: String,
      required: true,
      localizable: true,
      description: 'Title of the card',
    },
    text: {
      type: String,
      required: true,
      localizable: true,
      description: 'The body text of the card',
    },
    href: {
      type: Href,
      required: true,
      description:
        'URL that clicking the card will take you to, put the full url address if the url does not start with stripe.com/docs/',
    },
    icon: {
      type: ImageSrc,
      required: true,
      description:
        'Path to the images for the icon displayed on the left of the card',
    },
  },
};
